import { BuiltInComponents } from 'craft/constants';
import { SerializedNodeTree } from 'craft/types';

export const createFlowStep = (stepId: string) =>
  (({
    rootNodeId: '3bBlLh',
    nodes: {
      '3bBlLh': {
        type: {
          resolvedName: BuiltInComponents.FlowStep,
        },
        props: {
          stepId,
        },
        name: 'FlowStep',
      },
    },
  } as unknown) as SerializedNodeTree);
